module.exports = __webpack_public_path__ + "static/media/Setting.b4f031a8.svg";